import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';

import { SharedPipesModule } from 'src/pipes/shared-pipes.module';

import { ArticleTaxonomyAnalysisComponent } from './article-taxonomy-analysis/article-taxonomy-analysis.component';
import { CategoryAnalysisComponent } from './category-analysis/category-analysis.component';
import { SuperAdminTaxonomyRoutingModule } from './super-admin-taxonomy-routing.module';
import { SuperAdminTaxonomyComponent } from './super-admin-taxonomy.component';
import { SystemConfidenceAnalysisComponent } from './system-confidence-analysis/system-confidence-analysis.component';
import { TaxonomyDashboardComponent } from './taxonomy-dashboard/taxonomy-dashboard.component';
import { TaxonomyDimensionsListComponent } from './taxonomy-dimensions-list/taxonomy-dimensions-list.component';

@NgModule({
  declarations: [
    SuperAdminTaxonomyComponent,
    ArticleTaxonomyAnalysisComponent,
    CategoryAnalysisComponent,
    SystemConfidenceAnalysisComponent,
    TaxonomyDashboardComponent,
    TaxonomyDimensionsListComponent,
  ],
  imports: [
    CommonModule,
    HttpClientModule,
    RouterModule,
    IonicModule,
    NgxDatatableModule,
    SharedPipesModule,
    SuperAdminTaxonomyRoutingModule,
  ],
})
export class SuperAdminTaxonomyModule {}
